import { Eleve } from '@teetsh/app/src/types/eleves';
import {
  ClassroomMappingResult,
  EleveMappingResult,
} from './types/ClassroomActions';

export function partitionEleves(
  classroom: ClassroomMappingResult,
  eleves: Eleve[],
): {
  newEleves: EleveMappingResult[];
  updatedEleves: EleveMappingResult[];
  ignoredEleves: EleveMappingResult[];
  existingUnaffectedEleves: EleveMappingResult[];
} {
  const classroomEleves: EleveMappingResult[] = classroom.eleves.map(ev => ({
    ...ev,
    action: classroom.action === 'skip' ? 'skip' : ev.action,
  }));

  const newEleves = classroomEleves.filter(e => e.existingEleve === undefined);
  const updatedEleves = classroomEleves.filter(
    e => e.existingEleve !== undefined,
  );
  const ignoredEleves = classroomEleves.filter(e => e.action === 'skip');
  const existingUnaffectedEleves = eleves
    .filter(e => e.classroomId === classroom.id)
    .filter(e => !classroomEleves.some(ee => ee.existingEleve?.id === e.id))
    .map(e => ({ ...e, action: e.id, customFields: undefined }));

  return {
    newEleves,
    updatedEleves,
    ignoredEleves,
    existingUnaffectedEleves,
  };
}

export function countEleves({
  newEleves,
  updatedEleves,
  ignoredEleves,
  existingUnaffectedEleves,
}: {
  newEleves: EleveMappingResult[];
  updatedEleves: EleveMappingResult[];
  ignoredEleves: EleveMappingResult[];
  existingUnaffectedEleves: EleveMappingResult[];
}) {
  const newElevesCount = [
    ...newEleves.filter(e => e.action !== 'skip'),
    ...updatedEleves.filter(e => e.action === 'create'),
  ].length;

  const updatedElevesCount = updatedEleves.filter(
    e => e.action !== 'skip' && e.action !== 'create',
  ).length;

  const ignoredElevesCount = ignoredEleves.length;

  const existingUnaffectedElevesCount = existingUnaffectedEleves.length;

  return {
    newElevesCount,
    updatedElevesCount,
    ignoredElevesCount,
    existingUnaffectedElevesCount,
  };
}
